import React, { useState, useMemo } from 'react'
import { Box, useTheme } from '@mui/material'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'
import { useTimeline } from '../../api/aws/useTimeline'
import { useLayoutContext } from '../../context/LayoutProvider/LayoutProvider'
import { useParams } from 'react-router-dom'
import renderTaskTimelineColumns from '../DataGrid/createColumns/renderTaskTimelineColumns'
import {
  useGridApiRef,
  GridFilterModel,
  GridRowSelectionModel,
  GridSortModel,
  GridColumnVisibilityModel,
  GridColumnDimensions,
} from '@mui/x-data-grid-premium'
import GlobalDataGrid from 'components/DataGrid/GlobalDataGrid'
import { Timeline } from 'types'
import { timelineSxProps } from './timelineSxProps'
type TimelineResponse = {
  timeline: Timeline | Timeline[]
  isLoading: boolean
}

type TaskTimelineProps = {
  taskId?: string
  expanded?: boolean
}
const defaultFilterModel: GridFilterModel = { items: [], quickFilterValues: [] }
const defaultSortModel: GridSortModel = [{ field: 'timestamp', sort: 'desc' }]
const defaultVisibilityModel: GridColumnVisibilityModel = {
  dataset: false,
  id: false,
}
const defaultWidths = {
  user: 100,
  action: 200,
  details: 200,
  message: 200,
  dataset: 200,
  type: 200,
  timestamp: 100,
} as GridColumnDimensions
const TaskTimeline: React.FC<TaskTimelineProps> = () => {
  const { PK, SK } = useParams()
  const { pinned } = useLayoutContext()
  const { showSnackbar } = useSnackbarContext()
  const theme = useTheme()
  const apiRef = useGridApiRef()

  const { timeline, isLoading } = useTimeline(SK) as TimelineResponse
  console.log('timeline', timeline)
  const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>({
    ids: new Set<string>(),
    type: 'include',
  })
  const [filterModel, setFilterModel] = useState<GridFilterModel>({ items: [] })
  const [visibleRowCount, setVisibleRowCount] = useState(0)
  const [rowCount, setRowCount] = useState(0)
  const timelineRows = useMemo(() => {
    if (!timeline || isLoading) return []
    if (Array.isArray(timeline) && timeline?.length > 0)
      return timeline?.map(t => ({ ...t, rowId: `${t.timeline_uuid}-${t.timestamp}` }))
    else return []
  }, [timeline, isLoading])
  const columns = renderTaskTimelineColumns()

  const resizeColumns = () => {
    if (apiRef.current) {
      apiRef.current.updateColumns(columns)
    }
  }

  return (
    <Box
      sx={{
        // parent container: stretch + start at top
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100dvh',
        maxHeight: '100vh',
        // width: '100%',
        justifyContent: 'center',
        // remove any centering from shared styles
        alignItems: 'stretch',
        // your shared container bits
        // ...gridContainerStyles,
        gap: 0,
      }}
    >
      <GlobalDataGrid
        rows={timelineRows ?? []}
        columns={columns}
        apiRef={apiRef}
        context={'timeline'}
        defaultFilterModel={defaultFilterModel}
        defaultVisibilityModel={defaultVisibilityModel}
        defaultSortModel={defaultSortModel}
        defaultGridDensity={'standard'}
        defaultColumnWidths={defaultWidths}
        checkboxSelection={false}
        treeData={false}
        gridSxProps={timelineSxProps}
      />
    </Box>
  )
}

export default TaskTimeline
